import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';

import { DetailViewTabList } from 'components/TabList';
import { useAuth } from 'lib/auth';
import { PremiumBanner } from 'features/subscriptions/components/PremiumBanner';
import { useRateLots } from '../api/getRateLots';
import { LotRatesView } from './LotRatesView';

export const ratesTabName = 'rates';

export const RatesTab = ({ currentTab, resource, id, procurementName }) => {
  const { account, user } = useAuth();
  const isVisible = currentTab === ratesTabName;
  const hasAccess =
    !!account?.super_admin ||
    (!!user?.Company?.is_premium && user?.Company?.subscription_level === 'gold');
  const [lotId, setLotId] = useState(null);

  const { data: lots, isFetchedAfterMount } = useRateLots(resource, id, {
    enabled: isVisible && hasAccess,
  });
  const lot = lots.find(({ lot_id }) => lot_id === lotId) ?? lots[0];

  if (!isVisible) return null;

  if (!hasAccess) {
    return (
      <PremiumBanner
        sx={{ my: 0 }}
        message="Rates are available for Plus members. Click here for more information"
        currentLevel={user?.Company?.subscription_level}
      />
    );
  }

  if (isFetchedAfterMount && lots.length === 0) {
    return (
      <Stack flex={1} alignItems="center" justifyContent="center" gap={1} py={8}>
        <Typography variant="h5" fontWeight={700}>
          No rates yet
        </Typography>
        <Typography color="text.secondary">Rates will show here once they are added</Typography>
      </Stack>
    );
  }

  if (!lot) return null;

  return (
    <Stack gap={2}>
      <DetailViewTabList
        value={lot.lot_id}
        onChange={(_, value) => setLotId(value)}
        tabs={lots.map(({ lot_id, name }) => ({ label: name, value: lot_id }))}
        multi
      />

      <LotRatesView
        key={lot.lot_id}
        resource={resource}
        id={id}
        lot={lot}
        procurementName={procurementName}
      />
    </Stack>
  );
};
